import { Users } from "lucide-react";
import { RoleBadge, VerifiedBadge } from "@/components/badges";
import { Skeleton } from "@/components/ui/skeleton";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { BOARD_ROLES, initials } from "./shared";

export function BoardMembersPanel({ members }) {
  const board = (members || []).filter((m) => BOARD_ROLES.includes(m.role));
  const boardList = board.length ? board : (members || []);

  return (
    <div className="rounded-2xl border border-border/60 bg-card p-5 shadow-sm lg:col-span-2">
      <div className="mb-3 flex items-center gap-2">
        <Users className="h-4 w-4 text-primary" />
        <h2 className="font-headings text-lg font-bold tracking-tight">Styret</h2>
        <span className="rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground">{members ? boardList.length : ""}</span>
      </div>
      <div className="space-y-2.5" data-testid="styret-panel">
        {members === null
          ? Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} className="h-14 rounded-lg" />)
          : boardList.map((mb) => (
              <div key={mb.membership_id || mb.user_id} data-testid={`board-member-${mb.user_id}`} className="flex items-center gap-3 rounded-lg border border-border/50 bg-muted/20 px-3 py-2">
                <Avatar className="h-9 w-9"><AvatarImage src={mb.avatar || undefined} /><AvatarFallback className="bg-primary/10 text-xs font-semibold text-primary">{initials(mb.name)}</AvatarFallback></Avatar>
                <div className="min-w-0 flex-1">
                  <p className="flex items-center gap-1.5 truncate text-sm font-medium">
                    {mb.name}
                    {mb.identity_verified ? <VerifiedBadge label="Verifisert" testId={`member-verified-${mb.user_id}`} className="shrink-0 px-1.5 py-0" /> : null}
                  </p>
                  {mb.email ? <p className="truncate text-xs text-muted-foreground">{mb.email}</p> : null}
                </div>
                <RoleBadge role={mb.role} />
              </div>
            ))}
        {members && boardList.length === 0 ? <p className="text-sm text-muted-foreground">Ingen registrerte styremedlemmer.</p> : null}
      </div>
    </div>
  );
}
